<template>
  <div class="w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-4">
    <vs-card
      id="ro-cards-loading"
      class="vs-con-loading__container px-2 widget-card"
    >
      <card-header :title="$t('widget_review_oder_by_status')"></card-header>

      <vs-row class="py-6">
        <vs-col vs-w="6" class="pr-2">
          <statistics-card
            class="mb-base"
            icon="FileTextIcon"
            title="Ready for review"
            :statistic="cards.ready_review"
            color="#9B59B6"
          />
        </vs-col>
        <vs-col vs-w="6" class="pl-2">
          <statistics-card
            class="mb-base"
            icon="BellIcon"
            title="Reviewing"
            :statistic="cards.reviewing"
            color="#FF9F43"
          />
        </vs-col>
        <vs-col vs-w="6" class="pr-2">
          <statistics-card
            class="mb-base"
            icon="XCircleIcon"
            title="Rejected"
            :statistic="cards.rejected"
            color="#BC1300"
          />
        </vs-col>
        <vs-col vs-w="6" class="pl-2">
          <statistics-card
            class="mb-base"
            icon="CheckCircleIcon"
            title="Approved"
            :statistic="cards.approved"
            color="#28C76F"
          />
        </vs-col>
        <vs-col vs-w="6" class="pr-2">
          <statistics-card
            class="mb-base"
            icon="MapPinIcon"
            title="Review at Origin"
            :statistic="cards.review_origin"
            color="#7F8C8D"
          />
        </vs-col>
        <vs-col vs-w="6" class="pl-2">
          <statistics-card
            class="mb-base"
            icon="TruckIcon"
            title="Shipped"
            statistic="-"
            color="#D35400"
          />
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import StatisticsCard from '@/views/modules/import_export/review_order/components/StatisticsCard.vue'
import loading from '@/mixins/Loading'
import reviewOrder from '@/http/requests/reviewOrder'
import CardHeader from './CardHeader.vue'

export default {
  components: {
    StatisticsCard,
    CardHeader,
  },
  mixins: [loading],
  computed: {
    isLoading() {
      return this.loading.cards
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`ro-cards-loading`)
      } else {
        this.closeLoading(`ro-cards-loading`)
      }
    },
  },
  data() {
    return {
      cards: {
        ready_review: 0,
        reviewing: 0,
        rejected: 0,
        approved: 0,
        review_origin: 0,
      },
      loading: {
        cards: false,
      },
    }
  },
  mounted() {
    this.loadCards()
  },
  methods: {
    loadCards() {
      this.loading.cards = true
      let params = {}
      reviewOrder
        .getReviewCards(params)
        .then((res) => {
          let cards = res.data.data
          cards.forEach((item) => {
            switch (item.name) {
              case 'Ready for review':
                this.cards.ready_review = Number(item.total)
                break
              case 'Reviewing':
                this.cards.reviewing = Number(item.total)
                break
              case 'Rejected':
                this.cards.rejected = Number(item.total)
                break
              case 'Approved':
                this.cards.approved = Number(item.total)
                break
              case 'Review at Origin':
                this.cards.review_origin = Number(item.total)
                break
              default:
                break
            }
          })
          this.loading.cards = false
        })
        .catch((err) => {
          this.loading.cards = false
        })
    },
  },
}
</script>